// نرمال‌سازِ سراسریِ ارقام —
// هر عددِ فارسی/عربی که در هر <input>/<textarea>ِ برنامه تایپ یا paste شود،
// هنگامِ تایپ به‌صورتِ خودکار به رقمِ انگلیسی (ASCII) تبدیل می‌شود.
// یک‌بار در index.js نصب می‌شود؛ با Ant Design (InputNumber/Input) هم سازگار است.
// برای خروجِ اختیاری از یک فیلد: data-no-digit-normalize روی input.

const HAS_FA_AR = /[۰-۹٠-٩]/;

/** هر رقمِ فارسی (۰..۹) یا عربی (٠..٩) را به ASCII تبدیل می‌کند؛ بقیه دست‌نخورده. */
export function toEnglishDigits(input) {
  if (input == null) return input;
  return String(input)
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0))   // U+06F0..U+06F9
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660));   // U+0660..U+0669
}

// مقداردهیِ value با setterِ نیتیو تا value-trackerِ React تغییر را تشخیص دهد و onChange شلیک شود.
function setNativeValue(el, value) {
  const proto = el instanceof HTMLTextAreaElement
    ? HTMLTextAreaElement.prototype
    : HTMLInputElement.prototype;
  const desc = Object.getOwnPropertyDescriptor(proto, "value");
  if (desc && desc.set) desc.set.call(el, value);
  else el.value = value; // fallback
}

function onInput(e) {
  const el = e.target;
  if (!el || (el.nodeName !== "INPUT" && el.nodeName !== "TEXTAREA")) return;
  if (el.dataset && el.dataset.noDigitNormalize !== undefined) return;
  const v = el.value;
  if (!v || !HAS_FA_AR.test(v)) return;

  // تبدیل، با حفظِ موقعیتِ مکان‌نما (هر رقمِ فارسی = یک رقمِ انگلیسی → طول ثابت)
  const start = el.selectionStart;
  const end = el.selectionEnd;
  setNativeValue(el, toEnglishDigits(v));
  try { if (start != null) el.setSelectionRange(start, end); } catch { /* type=number/email caret */ }

  // رویدادِ تازه تا React/AntD مقدارِ انگلیسی‌شده را ببینند (رویدادِ تازه دیگر رقمِ فارسی ندارد → بدونِ حلقه)
  el.dispatchEvent(new Event("input", { bubbles: true }));
}

let installed = false;
/** نصبِ یک‌بارهٔ شنوندهٔ سراسری (فاز capture تا پیش از React اجرا شود). */
export function installDigitNormalizer() {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener("input", onInput, true);
}

// ─────────────────────────────────────────────────────────────
//  نمایشِ فارسیِ ارقامِ آمار (Statistic) — فقط مقدارِ عددیِ کارت‌های آمار
//  (محتوای این span‌ها همیشه عددِ نمایشی است؛ کد/شناسه را دست نمی‌زند)
// ─────────────────────────────────────────────────────────────
const FA_DIGITS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const toFaDisplay = (s) =>
  s.replace(/[0-9]/g, (d) => FA_DIGITS[+d]).replace(/,/g, "٬");
const STAT_SEL = ".ant-statistic-content-value-int, .ant-statistic-content-value-decimal";
// سلولِ «خالصِ عددی»: فقط رقم/جداکننده/اعشار — کد/تاریخ/کدِ‌رویداد (حاویِ حرف یا «-») رد می‌شوند
const PURE_NUM = /^[\s0-9۰-۹٠-٩,٬.٫]+$/;

/* 🔴 v2.170.0 — «مبلغ را کنارِ شماره فاکتور گذاشتیم، به‌جای مبلغ شماره فاکتور نشان داد».
   قبلاً اینجا `el.textContent = n` بود: گرهٔ متنیِ **خودِ React** دور ریخته و گرهٔ تازه جایش
   می‌نشست. React هنوز گرهٔ قدیمی (جداشده از صفحه) را نگه می‌داشت و رندرِ بعدی (جابه‌جاییِ ستون،
   مرتب‌سازی، صفحهٔ بعد) مقدارِ تازه را در همان گرهٔ نامرئی می‌نوشت ⇒ صفحه عددِ **کهنه** را نشان
   می‌داد (عددِ ستونِ قبلی/ردیفِ قبلی). حالا فقط `nodeValue`ِ همان گره‌ها عوض می‌شود؛ گره همان است
   و به‌روزرسانیِ بعدیِ React درست روی صفحه می‌نشیند. هرگز `textContent`/`innerHTML`ِ گرهٔ React را
   از بیرون بازنویسی نکن. */
function faTextNodes(el) {
  const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  for (let n = w.nextNode(); n; n = w.nextNode()) {
    const t = n.nodeValue;
    if (t && /[0-9,]/.test(t)) {
      const f = toFaDisplay(t);
      if (f !== t) n.nodeValue = f;
    }
  }
}

function scanStats() {
  // مقدارِ کارت‌های آمار
  document.querySelectorAll(STAT_SEL).forEach((el) => {
    if (/[0-9,]/.test(el.textContent)) faTextNodes(el);
  });
  // سلول‌های متنیِ خالصِ عددیِ جدول‌ها (سلول‌های دارای تگ/دکمه/کد رد می‌شوند)
  document.querySelectorAll(".ant-table-tbody td.ant-table-cell").forEach((el) => {
    if (el.children.length) return;            // فقط متنِ ساده
    const t = el.textContent;
    if (t && /[0-9]/.test(t) && PURE_NUM.test(t.trim())) faTextNodes(el);
  });
}

let statInstalled = false, statScheduled = false;
const scheduleScan = () => {
  if (statScheduled) return;
  statScheduled = true;
  (window.requestAnimationFrame || setTimeout)(() => { statScheduled = false; scanStats(); });
};
/** آمارهای AntD را به‌صورتِ سراسری فارسی‌رقم نگه می‌دارد (با MutationObserver). */
export function installStatNumeral() {
  if (statInstalled || typeof document === "undefined") return;
  statInstalled = true;
  scanStats();
  new MutationObserver(scheduleScan).observe(document.documentElement, {
    subtree: true, childList: true, characterData: true,
  });
}
